/**
 * The minimum largest safe size for a file chunk unit in bytes
 */ export const SafeFileUploadChunkSize = 327680; // 320kB
export const MaxFileUploadApiRetries = 3;
export const MaxFileUploadApiFileSize = 104857600; // 100MB
/**
 * Default chunk size for file uploads (10 MB)
 */ export const FILE_UPLOAD_CHUNK_SIZE = 10485760; // 10 MB
